import { combineReducers } from 'redux';
import { entitiesReducer, queriesReducer } from 'redux-query';
import { hotelBrandSelectionReducer } from './hotelBrandSelectionReducer';

const combineRootReducer = combineReducers({
    entities: entitiesReducer,
    queries: queriesReducer,
    hotelBrandSelection: hotelBrandSelectionReducer,
});

export default combineRootReducer;
